import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBus = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-bus-icon lucide-bus",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M8 6v6" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 6v6" }),
		/* @__PURE__ */ _jsx("path", { d: "M2 12h19.6" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7,
			cy: 18,
			r: 2
		}),
		/* @__PURE__ */ _jsx("path", { d: "M9 18h5" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 18,
			r: 2
		})
	]
});
export default SvgBus;
